import { useOnboardingProgress } from "@aurem/components";
import { useInitUserQuery } from "graphql/user";
import { useSyncChatwootUser } from "hooks/useSyncChatwootUser";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { ProgressPageName } from "types";
import { EmployeeLayout } from "../layouts/employee/EmployeeLayout";

export const EmployeeEntry = () => {
  const { isPageCompleted, loading: onboardingLoading } =
    useOnboardingProgress();
  const { loading: userLoading } = useInitUserQuery();
  useSyncChatwootUser();
  const location = useLocation();
  const { pathname, state } = location;
  const { language } = useParams<{ language: string }>();
  const from = state?.from;

  const disclaimersCompleted = isPageCompleted(ProgressPageName.Disclaimers);
  const onboardingCompleted = isPageCompleted(ProgressPageName.Onboarding);

  if (onboardingLoading || userLoading) {
    return null;
  }

  if (!disclaimersCompleted) {
    const isAtDisclaimers = pathname.includes("disclaimers");
    if (!isAtDisclaimers) {
      return (
        <Navigate
          to={`/${language}/employee/disclaimers`}
          replace
          state={state}
        />
      );
    }
    return <EmployeeLayout />;
  }

  if (!onboardingCompleted) {
    const isAtOnboarding = pathname.includes("onboarding");
    if (!isAtOnboarding) {
      return (
        <Navigate
          to={`/${language}/employee/onboarding/flag-details`}
          replace
          state={state}
        />
      );
    }
    return <EmployeeLayout />;
  }

  if (from) {
    return <Navigate to={from} replace />;
  }

  return <EmployeeLayout />;
};
